
import { defineComponent, computed, toRefs, PropType } from "vue";
import { colorTokens } from "../enums";
import "./icons.scss";

export default defineComponent({
  name: "adm-icon",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String as PropType<colorTokens>,
      default: "inherit",
    },
    // outlined, filled (default empty value), round, sharp, two-tone
    type: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { color, type } = toRefs(props);

    const classes = computed(() => [
      "material-icons",
      type.value ? `material-icons-${type.value}` : "",
      `adm-color--${color.value}`,
    ]);

    return {
      classes,
    };
  },
});
